module.exports = __webpack_public_path__ + "static/media/chris-cieslok.7a7809cb.png";